export const PREMIUM_COPY_MODAL_ID = 'premium-copy-modal-id'
export const PREMIUM_COPY_MODAL_FOOTNOTE_CONTAINER_ID =
  'premium-copy-modal-footnote-container'
export const PREMIUM_COPY_MODAL_INTEXT_CONTAINER_ID =
  'premium-copy-modal-intext-container'
